<template>
	<img
		v-if="imageUrl && !imageFailed"
		:src="imageUrl"
		class="avatar rounded-circle object-cover"
		:class="{ 'bg-darkish': dark }"
		:style="{ width: getSize(size), height: getSize(size) }"
		loading="lazy"
		@error="imageFailed = true"
	/>
	<div
		v-else
		class="avatar text-white rounded-circle d-inline-flex flex-column flex-shrink-0 align-items-center justify-content-center"
		:class="[{ small: size === 'sm' }, fallbackBackgroundClass]"
		:style="{
			backgroundColor: getFallbackBackgroundColor(),
			width: getSize(size),
			height: getSize(size)
		}"
	>
		<span
			class="d-inline-flex align-items-center justify-content-center w-100 h-100"
			:style="fallbackTextStyle"
		>
			{{ fallback.substring(0, 2) }}
		</span>
	</div>
</template>
<script>
import { stringToColor } from '~/util/helpers'
export default {
	props: {
		image: {
			// Missing media can be serialized as an empty array by API resources.
			type: [Object, Array],
			default: null
		},

		fallback: {
			type: String,
			default: ''
		},
		fallbackBackgroundColor: {
			type: String,
			default: null
		},
		fallbackBackgroundClass: {
			type: String,
			default: null
		},

		dark: {
			type: Boolean,
			default: false
		},

		size: {
			type: String,
			default: null
		}
	},
	computed: {
		imageUrl() {
			return typeof this.image?.url === 'string'
				? this.image.url.trim()
				: ''
		},
		fallbackTextStyle() {
			return {
				color: 'var(--Color-Solid-White, #FFF)',
				textAlign: 'center',
				fontFamily: 'Roboto',
				fontSize: '12px',
				fontStyle: 'normal',
				fontWeight: 500,
				lineHeight: 'normal',
				letterSpacing: '0'
			}
		}
	},
	watch: {
		imageUrl() {
			this.imageFailed = false
		}
	},

	data() {
		return {
			imageFailed: false
		}
	},

	methods: {
		stringToColor(input) {
			return stringToColor(input)
		},
		getFallbackBackgroundColor() {
			if (this.fallbackBackgroundClass) return undefined
			if (this.fallbackBackgroundColor) {
				return this.fallbackBackgroundColor
			}

			return stringToColor(this.fallback)
		},

		getSize(size) {
			if (
				typeof size === 'string' &&
				/^\d+(\.\d+)?(px|rem|em|%)$/.test(size)
			) {
				return size
			}

			if (size === 'sm') {
				return '1.5rem'
			}

			return '2.5rem'
		}
	}
}
</script>
